import React, { useContext, useEffect } from "react";
import { Autocomplete, FilterBar, SearchBar, Switch } from "@sscs/ui";
import { produce } from "immer";
import { initFilter, selectFilteredByLink, } from "../../../store/networkingSlice";
import { ClassificationFilter } from "../../common";
import { ReportContext } from "../../context";
import { useReportSelector } from "../../hooks";
import { useLazyGetNetworkingTagsQuery } from "../../services/networking.api";
import { isFilteredByLink } from "../../utils";
import styles from "./filter.module.scss";
const Filter = ({ filter, onFilterChange }) => {
    var _a;
    const { reportId } = useContext(ReportContext);
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const [fetchTags, { data: tags, isFetching: isTagsFetching }] = useLazyGetNetworkingTagsQuery();
    const tagOptions = [
        {
            id: "ALL",
            value: "Show all tags",
        },
        ...((_a = tags === null || tags === void 0 ? void 0 : tags.map((tag) => ({
            id: tag.id,
            value: `Filtered by ${tag.value}`,
        }))) !== null && _a !== void 0 ? _a : []),
    ];
    useEffect(() => {
        // fetch options if non-default option was selected
        if (filter.tag !== "ALL") {
            fetchTags({ ui_id: reportId });
        }
    }, [filter, fetchTags, reportId]);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "search-regex",
                control: (React.createElement(SearchBar, { id: "networking-input", value: filter.search_regex, label: "Type regex pattern to search for strings", onChange: (value) => onFilterChange(produce(filter, (draftFilter) => {
                        draftFilter.search_regex = value;
                    })), slotProps: { htmlInput: { maxLength: 256 } }, className: styles["search-bar"], fullWidth: false, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "search_regex", filteredByLink) })),
            },
            {
                id: "classification",
                width: "275px",
                control: (React.createElement(ClassificationFilter, { classification: filter.classification, onChange: (value) => onFilterChange(produce(filter, (draftFilter) => {
                        draftFilter.classification = value;
                    })) })),
            },
            {
                id: "tag",
                width: "275px",
                control: (React.createElement(Autocomplete, { id: "networking-filter-tags", label: "Filter by tag", isClearAlwaysVisible: filter.tag !== initFilter.tag, value: filter.tag, options: tagOptions.map((option) => option.id), getOptionLabel: (option) => { var _a; var _b; return (_b = (_a = tagOptions.find((tag) => tag.id === option)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ""; }, onChange: (_event, value) => {
                        onFilterChange(produce(filter, (draftFilter) => {
                            draftFilter.tag = value;
                        }));
                    }, onOpen: () => fetchTags({ ui_id: reportId }), loading: isTagsFetching })),
            },
            {
                id: "has-services",
                fit: true,
                control: (React.createElement(Switch, { title: "Filter networking", label: "With services", checked: filter.has_services, onChange: (event) => onFilterChange(produce(filter, (draftFilter) => {
                        draftFilter.has_services = event.target.checked;
                    })) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map